/**
 * Text Formatting Utilities
 * Helper functions for consistent text formatting across the app
 */

/**
 * Convert a string to title case, handling special cases for meal names
 * @param str The string to convert
 * @returns The title cased string
 */
export function toTitleCase(str: string): string {
    if (!str) return "";

    // Words that should remain lowercase unless they start the string
    const exceptions = [
        "with",
        "and",
        "or",
        "in",
        "on",
        "at",
        "to",
        "for",
        "of",
        "a",
        "an",
        "the",
    ];

    // Special food-related acronyms that should stay uppercase
    const acronyms = ["BBQ", "PB&J", "BLT"];

    return str
        .split(" ")
        .map((word, index) => {
            // Check if it's an acronym
            if (acronyms.includes(word.toUpperCase())) {
                return word.toUpperCase();
            }

            // First word is always capitalized
            if (index === 0) {
                return (
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                );
            }

            // Check if it's an exception word
            if (exceptions.includes(word.toLowerCase())) {
                return word.toLowerCase();
            }

            // Otherwise, capitalize first letter
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
}

/**
 * Format meal type for display (e.g., "breakfast" -> "Breakfast")
 * @param mealType The meal type to format
 * @returns The formatted meal type
 */
export function formatMealType(mealType: string): string {
    return mealType.charAt(0).toUpperCase() + mealType.slice(1);
}
